import React from "react"
import { isNull, isEqual } from "lodash";

import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';
import {cloneObject, getParam} from '../utils/utils';

import dsd from "../classes/clsDSD";

import { Plus, Trash, ArrowUp, ArrowDown } from 'react-bootstrap-icons';

import SelectCapability from "./SelectCapability";


class FormDependency extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            edited: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleButton = this.handleButton.bind(this);

        this.dsd = new dsd();
        this.FallBackNavigation = `.`;
    }

    componentDidMount(){

       this.setup();

    }

    componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
    
    setup(){

        let StateChange = {

            FormData: {},
            Dependency: null,
            seq: null,

            idSolution: null,

            onAdd: null,
            onRemove: null,
            onUpdate: null,
            onMoveUp: null,
            onMoveDown: null,

        }

        StateChange.onAdd = getParam('onAdd', this.props);
        StateChange.onRemove = getParam('onRemove', this.props);
        StateChange.onUpdate = getParam('onUpdate', this.props);
        StateChange.onMoveUp = getParam('onMoveUp', this.props);
        StateChange.onMoveDown = getParam('onMoveDown', this.props);

        StateChange.mode = getParam('mode', this.props) || 'edit';
        StateChange.seq = getParam('seq', this.props);

        StateChange.Dependency = getParam('Dependency', this.props);
        if (isNull(StateChange.Dependency)){
            StateChange.Dependency = {};
        }

        StateChange.idSolution = getParam('idSolution', this.props);

        StateChange.FormData = cloneObject(StateChange.Dependency);
        
        this.setState(StateChange);


    }

    handleButton(event) {
    
        let StateChange = {};

        switch (event.currentTarget.name){
            case 'btnAdd':
                StateChange.mode = 'edit';

                if (this.state.onAdd){
                    this.state.onAdd();
                    break;
                }
                break;
            case 'btnDelete':

                if (this.state.onRemove){
                    this.state.onRemove(this.state.seq);
                    break;
                }

                break;

            case 'btnUp':

                if (this.state.onMoveUp){
                    this.state.onMoveUp(this.state.seq);
                    break;
                }

                break;

            case 'btnDown':

                if (this.state.onMoveDown){
                    this.state.onMoveDown(this.state.seq);
                    break;
                }

                break;

        }
    
        this.setState(StateChange);
    
        event.preventDefault();    

    }

    handleChange(event) {
        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let FormData = this.state.FormData;
        FormData[FormFieldName] = FormFieldValue;
        this.setState({FormData: FormData});

        if (this.state.onUpdate){
            this.state.onUpdate(this.state.seq, FormData);
        }
    }



    render() {
        if (!this.state.FormData) {
            return null;
        }

        switch (this.state.mode){
            case 'new':
            case 'edit':
                
                return (
                    <form>
                        <PD.Table type="list">
                            <PD.Tr>
                                <PD.Td>
                                    {(() => {
                                        switch (this.state.mode) {
                                            case "new": 
                                                return <button name="btnAdd" onClick={this.handleButton}><Plus/></button>;
                                            case "edit": 
                                                return(
                                                    <div>
                                                        <div>
                                                            <button name="btnDelete" onClick={this.handleButton}><Trash/></button>
                                                        </div>
                                                        {this.state.onMoveUp &&
                                                            <div>
                                                                <button name="btnUp" onClick={this.handleButton}><ArrowUp/></button>
                                                            </div>
                                                        }
                                                        {this.state.onMoveDown &&
                                                            <div>
                                                                <button name="btnDown" onClick={this.handleButton}><ArrowDown/></button>
                                                            </div>
                                                        }
                                                    </div>
                                                );                                                
                                        }
                                    })()}
                                </PD.Td>
                                {this.state.mode == 'edit' &&
                                    <React.Fragment>
                                        <PD.Td>
                                            <PD.Select label="Type" name="type" onChange={this.handleChange} value={this.state.FormData.type}>
                                                {this.dsd.config.DependencyTypes && this.dsd.config.DependencyTypes.map((type, index) => (
                                                    <option key={index} value={type}>{type}</option>
                                                ))}
                                            </PD.Select>
                                        </PD.Td>
                                        <PD.Td>
                                            <SelectCapability label='Capability' name="idCapability" idSolution={this.state.idSolution} onChange={this.handleChange} value={this.state.FormData.idCapability}/>
                                        </PD.Td>
                                        <PD.Td>
                                            <PD.Editor label="Description" name="description" value={this.state.FormData.description} onChange={this.handleChange}/>
                                        </PD.Td>
                                    </React.Fragment>
                                }
                            </PD.Tr>
                        </PD.Table>
                    </form>
                );
            default:
                return null;
        }
    }
}

export default FormDependency;
